var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ display: 'flex' })},[_c('Months',{ref:"months",attrs:{"onChange":_vm.onMonthChange}}),_c('DayOfMonth',{ref:"dayOfMonth",attrs:{"includeLast":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }